import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/lib/api/client'
import type { SearchResults } from '../types'

/** Server-side search across every module the caller may see. */
export function useGlobalSearch(term: string, enabled: boolean) {
  return useQuery({
    enabled: enabled && term.trim().length >= 2,
    queryKey: ['search', term],
    queryFn: async () =>
      (await apiClient.get<SearchResults>('/v1/search', { params: { q: term } })).data,
    staleTime: 30_000,
  })
}
